var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"white--text",attrs:{"color":_vm.iconColor,"label":"","variant":"flat"}},[(_vm.evolutionValue >= 0)?_c('span',{staticClass:"mr-1"},[_vm._v("+")]):_vm._e(),_vm._v(_vm._s(_vm._f("roundNumber")(_vm.evolutionValue,0))+" "+_vm._s(_vm.unite)+" "),_c('v-icon',[_vm._v(" "+_vm._s(_vm.iconName)+" ")]),_vm._v(" * ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }